function OrganizationRiskLevel() {
    "use strict";

    this._type = 'OrganizationRiskLevel:www.veritracks.com';
    //this.Id = -1;
    //this.OrganizationId = -1;
    //this.OriZoneClassifyId = -1;
    //this.ZoneClassificationId = -1;
    //this.RiskLevelId = -1;
    //this.RiskLevelName = '';
    //this.SortOrder = -1;
    //this.UpdatedUTC = -1;
}